const DEFAULT_API_BASE = import.meta.env.VITE_API_BASE ?? '/api';

let apiBase = DEFAULT_API_BASE;

export function getApiBase() {
  return apiBase;
}

export function setApiBase(value?: string) {
  if (typeof value === 'string' && value.trim().length > 0) {
    apiBase = value.trim();
    return;
  }
  apiBase = DEFAULT_API_BASE;
}

export function resetApiBase() {
  apiBase = DEFAULT_API_BASE;
}
